export default __webpack_public_path__ + "static/media/OM.ce783269.svg";